import * as React from 'react';
import Select from 'react-select';
import {Option} from '../../../Config/dataModel';
import { reactSelectStyles } from 'src/Components/constants';

interface InvitationDropDownProps {
    companyOptions: Option[],
    selectedCompany: Option,
    changeCompany: (company: Option) => void
}

class InvitationDropDown extends React.Component <InvitationDropDownProps, {}> {
    public render() {
        return (
            <div className="invitationDropDown">
                <Select
                    styles={reactSelectStyles}
                    className="react-select__container"
                    classNamePrefix="react-select"
                    options={this.props.companyOptions}
                    value={this.props.selectedCompany}
                    clearable={false}
                    placeholder="Add Sub-agent Company to the list"
                    onChange={(company) => this.props.changeCompany(company)}/>
            </div>
        );
    }
}

export default InvitationDropDown;



// WEBPACK FOOTER //
// ./src/Components/Contact/Invitation/InvitationDropDown.tsx